import { findLocationsByPlaceId as findLocationsByPlaceIdOp } from '@gql/operations'
import { type GqlExecutor } from '@hopdrive/sdk-core'
import type { Location } from '../../types'

export interface FindByPlaceIdParams {
  customerId: number
  placeId: string
  executor?: GqlExecutor
}

/**
 * Find location by Google Place ID.
 */
export async function findLocationByPlaceId(params: FindByPlaceIdParams): Promise<Location | null> {
  const locations = await findLocationsByPlaceIdOp(
    { customerId: params.customerId, placeId: params.placeId },
    { executor: params.executor }
  )

  return (locations?.[0] as Location) ?? null
}
